const data = {
    table: {
        columns: [
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 20
    },
}

export default data
